// src/i18n-lite.ts
// [修改点 1] 直接从法律字典导入，不再经过主 store，让打包后的 JS 更小
import { LEGAL_DICT } from "./taskpane/modules/i18n_legal";

/**
 * 极简 I18N 处理：根据 URL 参数自动切换语言，并移除 Cloak 遮罩
 * [Phase 1.6] 增强判定逻辑：优先URL参数，其次浏览器语言，最后兜底
 */
function applyStaticI18n() {
    // 1. 优先级重构：URL参数 > 浏览器语言 > 兜底
    let lang: "en" | "zh" = "en"; // 默认英文（符合商店审核要求）
    
    // 1.1 优先读取 URL 中的 lang 参数
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get("lang");
    
    if (urlLang === "zh") {
        lang = "zh";
    } else if (urlLang === "en") {
        lang = "en";
    } else {
        // 1.2 若无参数，尝试读取浏览器语言
        const browserLang = window.navigator.language.toLowerCase();
        // 使用与主应用相同的判定算法：startsWith('en') ? 'en' : 'zh'
        lang = browserLang.startsWith("en") ? "en" : "zh";
    }
    
    // 1.3 日志强化：记录判定过程
    console.log(`[i18n-lite] URL参数: ${urlLang}, 浏览器语言: ${window.navigator.language}, 最终判定: ${lang}`);
    
    // [修改点 2] 使用 LEGAL_DICT 替代 I18N_DICT
    const dict = LEGAL_DICT[lang];

    // 2. 遍历带有 data-i18n 的元素
    document.querySelectorAll("[data-i18n]").forEach(el => {
        const key = el.getAttribute("data-i18n");
        // @ts-ignore - 这里的 key 肯定在字典里，或者我们允许它不存在时跳过
        if (key && dict[key]) {
            // 如果是页面标题，特殊处理
            if (el.tagName === "TITLE") {
                document.title = dict[key];
            } else {
                // [修改点 3] 使用 textContent 替换 innerHTML，确保安全
                // 根据宪法第四章第2条：严禁直接操作 innerHTML
                el.textContent = dict[key];
            }
        }
    });

    // 3. 翻译完成，揭开"斗篷"
    document.body.classList.remove("cloak");
}

// 确保在 DOM 加载完成后运行
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyStaticI18n);
} else {
    applyStaticI18n();
}
